import UpDownNumberInput from "./UpDownNumberInput";

export const upDownNumberInput = {
  init: () => {
    const el = document.querySelectorAll(".sd-up-down-number-input");
    [...el].forEach((item) => new UpDownNumberInput(item));
  },
};

export default UpDownNumberInput;
